export default __webpack_public_path__ + "static/media/twitter-filled.3a04af4f.svg";